import React from "react";
import {
  HeroSection,
  BreadCrumbs,
  Container,
  Typography,
} from "../../components";
import usePageContent from "../../hooks/usePageContent";
import ReactHtmlParser from "react-html-parser";

export default () => {
  const { isLoading, data } = usePageContent("about-us");

  return (
    <>
      <HeroSection
        title={data?.title ? data.title : "About Us"}
        description={data?.sub_title ? data.sub_title : " "}
      />
      <Container>
        <BreadCrumbs
          data={[{ title: data?.title ? data.title : "About Us" }]}
        />
        {isLoading ? (
          <Typography h3>Loading...</Typography>
        ) : (
          <Typography commonContainer>
            {ReactHtmlParser(data.content)}
          </Typography>
        )}
      </Container>
    </>
  );
};
